module.exports = __webpack_public_path__ + "static/media/homepage-section-2-clients.5bde961f.png";